import { defineMetabaseAuthConfig } from "@metabase/embedding-sdk-react";

// Metabase Configuration
// TODO: Replace these placeholder values with your actual Metabase credentials
// 1. METABASE_INSTANCE_URL: Your Metabase instance URL (e.g., https://your-instance.metabase.com)
// 2. METABASE_API_KEY: API key created in Admin Settings > Authentication > API keys
// 3. DASHBOARD_ID: Your dashboard ID from Metabase

export const METABASE_CONFIG = {
  instanceUrl: "https://beachy-sole.metabaseapp.com",
  apiKey:  "mb_EP4BWxPlLmdGVMbAT+X5VpU8OBTrpoi/SYuw57Wltck=",
  dashboardId: "10-titan-dev"
};

// Auth configuration for Metabase SDK
export const authConfig = defineMetabaseAuthConfig({
  metabaseInstanceUrl: METABASE_CONFIG.instanceUrl,
  apiKey: METABASE_CONFIG.apiKey,
});

// Note: API key authentication is for development/testing only (localhost)
// For production, you must implement JWT SSO authentication
// See: https://www.metabase.com/docs/latest/embedding/sdk/authentication